import { render, staticRenderFns } from "./cardAnuncio.vue?vue&type=template&id=0b60921e&scoped=true"
import script from "./cardAnuncio.vue?vue&type=script&lang=js"
export * from "./cardAnuncio.vue?vue&type=script&lang=js"
import style0 from "./cardAnuncio.vue?vue&type=style&index=0&id=0b60921e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b60921e",
  null
  
)

export default component.exports